import { BeamProvider } from "@homebound/beam";
import { PropsWithChildren } from "react";
import { NavigationContextProvider } from "src/components";
import { getBackendStage } from "src/context";
import { AppNotificationsProvider } from "src/contexts/AppNotificationsContext";
import { BlueprintProvider } from "src/contexts/BlueprintContext";
import { FeatureFlagProvider } from "src/contexts/FeatureFlags/FeatureFlagContext";
import { TrackedJobsProvider } from "src/contexts/TrackedJobsContext";
import { LocalCssReset } from "src/utils/LocalCssReset";

/**
 * Logged-in provider stack used by `AuthenticatedShell`.
 */
export function AppProviders(props: PropsWithChildren) {
  return (
    <BeamProvider documentTitleConfig={{ env: getBackendStage(), suffix: "Blueprint | Homebound" }}>
      <LocalCssReset />
      <NavigationContextProvider>
        <BlueprintProvider>
          <FeatureFlagProvider>
            <AppNotificationsProvider>
              <TrackedJobsProvider>{props.children}</TrackedJobsProvider>
            </AppNotificationsProvider>
          </FeatureFlagProvider>
        </BlueprintProvider>
      </NavigationContextProvider>
    </BeamProvider>
  );
}
